/**
 * @callback ResetFieldsCallback
 * @param {...*} args
 * @returns {void}
 */
/**
 * @callback PopupOKCallback
 * @param {...*} args
 * @returns {void}
 */
/**
 * @typedef PopupHelperOptions
 * @type {object}
 * @property {ResetFieldsCallback} resetFieldsCallback
 * @property {PopupOKCallback} popupOKCallback
 */

class PopupHelper
{
	/** @type {string} */
	_containerSelector;
	/** @type {PopupHelperOptions} */
	_options

	/**
	 * @param {string} containerSelector 
	 * @param {PopupHelperOptions} options 
	 */
	constructor(containerSelector, options)
	{
		this._containerSelector = containerSelector;
		this._options = options;

	}

	get containerSelector()
	{
		return this._containerSelector;
	}

	open(...args)
	{
		this._resetPopup(...args);
		this._setupAndOpenPopup(...args);
	}

	showLoading()
	{
		$(this._containerSelector).addClass('loading');
	}

	hideLoading()
	{
		$(this._containerSelector).removeClass('loading');
	}

	close()
	{
		closePopup(this._containerSelector);
	}
	/**
	 * @param {string} html 
	 */
	setContent(html)
	{
		$(`${this._containerSelector} .content`).html(html);
	}

	_resetPopup(...args)
	{
		this._options?.resetFieldsCallback?.(...args);
		this._resetErrors();
	}

	_resetErrors()
	{
		const $errors = $(`${this._containerSelector} .error-list`);
		$errors.children().remove();
		$errors.hide();
	}

	_setupAndOpenPopup(...args)
	{
		const thisObj = this;
		const okAction = function (e)
		{
			thisObj._options?.popupOKCallback?.(...args);
		};

		const primaryButtonSelector = `${this._containerSelector} .icon-action-button, ${this._containerSelector} .primary-action-button`;

		const closeAction = function ()
		{
			$(primaryButtonSelector).off("click", okAction);
		};

		$(primaryButtonSelector).on("click", okAction);
		openPopup(this._containerSelector, closeAction);
	}
	/**
	 * 
	 * @param {JQuery.jqXHR} response 
	 */
	defaultResponseErrorHandler(response)
	{
		this.defaultErrorHandler(response.responseJSON.message);
	}
	/**
	 * @param {string} error 
	 */
	defaultErrorHandler(message)
	{
		this._resetErrors();
		const $errors = $(`${this._containerSelector} .error-list`);
		$errors.show();
		$errors.append(`<li>${message}</li>`);
	}
}
